/**
 * @generated SignedSource<<edd9a412b538d4703909a8fded929c62>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$data = {
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"formatRules_businessConditionalFormattingSidebar_FormatRulesFragment">;
  readonly " $fragmentType": "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner";
};
export type container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$key = {
  readonly " $data"?: container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$data;
  readonly " $fragmentSpreads": FragmentRefs<"container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "name": "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "kind": "FragmentSpread",
      "name": "formatRules_businessConditionalFormattingSidebar_FormatRulesFragment"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "4893d87b377f4acd3e41cdfec3e94ad7";

export default node;
